import { API_ENDPOINT } from './config';

export const urlsEvaluation = {
  evaluationFunctions: `${API_ENDPOINT}/evaluation-functions`,
  evaluationFunctionDetail: (id) =>
    `${API_ENDPOINT}/evaluation-functions/${id}`,
  evaluationFunctionRun: (id) =>
    `${API_ENDPOINT}/evaluation-functions/${id}/run`,
};

export const routesEvaluation = {
  cmsEvaluationFunctions: '/cms/evaluation/functions',
  cmsEvaluationFunctionCreate: '/cms/evaluation/functions/create',
  cmsEvaluationFunctionEdit: '/cms/evaluation/functions/edit', // môžeš doplniť param ?id
};
